import React, { useEffect, useState, useContext, useMemo, useRef } from 'react';
import { debounce, findIndex } from 'lodash';
import axios, { AxiosError } from 'axios';
import APIService from '@shared/services/api';
import List from '@shared/component/List';
import Notify from '@shared/notify';
import TextInput from '@shared/component/TextInput';
import { AuthContext } from '@shared/context/AuthContext';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import DropDown from '@shared/component/DropDown';
import CheckValidator from '@shared/checkValidator';
import { useLocalStorage } from '@shared/auth/useLocalStorage';
import Lists from '@shared/component/Lists';
import { ActionValues, actionsPermissionValidator } from '@utils/static/commonUtils';

function UserManagement() {
    const { getStorageItem }: any = useLocalStorage();
    const user = getStorageItem('user') ? JSON.parse(getStorageItem('user')) : false;
    const [errors, setError] = useState<any>({
        name: {
            required: true,
            error: true,
            message: 'Please enter name',
            // pattern: /^[A-Za-z0-9\s.]*$/,
            pattern: /^[A-Za-z ]+$/g, ///^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)\s*$/g,
            maxLength: 50,
        },
        phone: {
            required: true,
            error: true,
            message: 'Please enter phone number',
            pattern: /^[6-9]{1}[0-9]{9}$/,
            maxLength: 10,
        },
        roleId: {
            required: true,
            error: true,
            message: 'Please select role',
        },
        password: {
            required: true,
            error: true,
            message: 'Please enter password',
            maxLength: 18,
        },
        demandType: {
            required: true,
            error: true,
            message: 'Please select demand type',
        },
    });
    const listRef: any = useRef(null);
    const { setLoader }: any = useContext(AuthContext);
    const [assign, setAssign] = useState([]);
    const [webUser, setWebUser] = useState([]);
    const [recordCount, setRecordCount] = useState(0);
    const [isSubmit, setIsSubmit] = useState(false);
    const [editItemId, setEditItemId] = useState(null);
    const [defaultPassword, setDefaultPassword] = useState('');
    const [passwordType, setPasswordType] = useState(false);
    const [edit, setEdit] = useState(false);
    const [showPassword, setShowPassword] = useState('password');
    const [editData, setEditData] = useState({
        name: null,
        phone: null,
        roleId: null,
        // userRoleId: '',
        password: null,
        demandType: null,
    });

    const [userData, setUser] = useState<any>({
        name: null,
        phone: null,
        roleId: null,
        // userRoleId: '',
        password: null,
        demandType: null,
    });
    const [showHideModel, setShowHideModel] = useState(false);
    const [demandTypeArray, setdemandTypeArray] = useState([
        { name: 'Manual', value: 'manual' },
        { name: 'Auto', value: 'auto' },
        { name: 'Both', value: 'both' },
    ]);
    const [columns, setColumns] = useState({
        id: 'ID',
        phone: 'Mobile No',
        name: 'Full Name',
        'user_role.name': 'Assigned Role',
        status: 'Status',
        // action: 'Action',
        ...(actionsPermissionValidator(location.pathname, ActionValues.Edit) ? { action: 'Action' } : null),
    });

    const checkFormValidate = () => {
        return new Promise(async (resolve, reject) => {
            try {
                // if (Object.values(userData).length == 0) {
                //     return resolve(false);
                // }
                // const d = Object.values(userData).some((value: any) => value === null);
                // resolve(!d);

                if (edit) {
                    errors['password'] = {
                        required: false,
                        error: false,
                        message: 'Please enter password',
                        maxLength: 18,
                    };
                } else {
                    errors['password'] = {
                        required: true,
                        error: true,
                        message: 'Please enter password',
                        maxLength: 18,
                    };
                }

                const d = await CheckValidator(errors, userData);
                resolve(d);
            } catch (error) {
                resolve(false);
            }
        });
    };

    const handelModel = (flag: boolean) => {
        try {
            setShowHideModel(flag);
            setIsSubmit(false);
            if (edit) {
                clearEditObjData();
                setEdit(false);
            }
            clearObjData();
        } catch (error) {}
    };

    // get value
    const getValue = (e: any) => {
        try {
            const data = { ...userData, ...e };
            setUser(data);
            // if (Object.values(e)?.[0] !== null) {
            //     if (edit) {
            //         const data = { ...editData, ...e };
            //         setEditData(data);
            //     }
            //     const data = { ...userData, ...e };
            //     setUser(data);
            // }
        } catch (error) {
        } finally {
            setLoader(false);
        }
    };

    const updateStatus = async (item: any, status: any, id: any, page: any, search: any) => {
        try {
            setLoader(true);
            const data = {
                status: status,
            };

            const updateddata = await APIService.update(`user/update/webUserStatus`, id, data, true, true);
            if (updateddata.status === 200) {
                // getAllWebUser(page);
                searchItem(search.trim(), page);
                Notify('success', 'User type status updated');
            }
            setLoader(false);
        } catch (err) {}
    };

    const searchItem = async (value: any, page: any) => {
        try {
            if (!page) {
                page = 1;
                listRef.current.resetPagination();
            }
            const data = await APIService.getAll(
                `user/webuser/search/get?page=${page}&order=desc&sort=createdAt&search=${value}`,
                true,
                false,
            );
            setWebUser(data.data.data);
            setRecordCount(data.data.count);
        } catch (err) {}
    };

    const getAllUserRole = async () => {
        try {
            setLoader(true);
            const data = await APIService.getAll(`user/get/allUser/Roles/?sort=createdAt&type=active`, true, false);

            setAssign(data.data.data);
        } catch (err) {
            setLoader(false);
        }
    };

    const getAllWebUser = async (page: any = 1) => {
        try {
            setLoader(true);
            const data = await APIService.getAll(`user/get/allWeb/user/?page=${page}&sort=createdAt`, true, false);
            setRecordCount(data?.data?.count || 0);
            const list = data?.data?.data ? data.data.data : [];
            const idx = findIndex(list, { id: user?.id });
            if (idx >= 0) {
                list.splice(idx, 1);
            }
            setWebUser(list);
            setLoader(false);
        } catch (err) {}
    };

    const addUser = async () => {
        try {
            const isValid = await checkFormValidate();
            setIsSubmit(!isValid);
            if (isValid) {
                const data = {
                    name: userData.name,
                    phone: userData.phone,
                    roleId: userData.roleId,
                    password: userData.password,
                    demandType: userData.demandType == undefined ? 'manual' : userData.demandType.toLowerCase(),
                };
                setLoader(true);
                const updateddata = await APIService.post('user/', data, true, false);
                setLoader(false);
                if (updateddata && updateddata.status === 200) {
                    getAllWebUser();
                    handelModel(false);
                    Notify('success', 'User created successfully');
                    listRef.current.clearSearchBox();
                }
            }
        } catch (err) {
        } finally {
            setLoader(false);
        }
    };

    // edit webuser

    const editWebUser = async () => {
        try {
            const isValid = await checkFormValidate();
            setIsSubmit(!isValid);
            if (isValid) {
                const data: any = {
                    name: userData.name,
                    phone: userData.phone,
                    roleId: userData.roleId,
                    demandType: userData.demandType?.toLowerCase(),
                };
                if (userData.password && userData.password.trim()?.length > 0) {
                    data['password'] = userData.password.trim();
                }
                setLoader(true);
                const updateddata = await APIService.update(
                    `user/update/webUserDetails`,
                    editItemId,
                    data,
                    true,
                    false,
                );
                setLoader(false);
                if (updateddata && updateddata.status === 200) {
                    handelModel(false);
                    Notify('success', 'User Edited successfully');
                    getAllWebUser();
                    listRef.current.clearSearchBox(true);
                }
            }
        } catch (error) {
        } finally {
            setLoader(false);
        }
    };

    const handleEdit = (itemId: any) => {
        const itemToEdit: any = webUser.find((item: any) => item.id === itemId);
        if (itemToEdit) {
            itemToEdit['roleId'] = itemToEdit.userRoleId;
            setEdit(true);

            errors['password'] = {
                required: false,
                error: false,
                message: 'Please enter password',
                maxLength: 18,
            };

            handelModel(true);
            setEditItemId(itemId);
            setEditData({ ...itemToEdit });
            delete itemToEdit.password;
            setUser({ ...itemToEdit });
        }
    };

    const getDeleteIds = async (ids: any) => {
        try {
            setLoader(true);
            const data = {
                ids: JSON.stringify(ids),
            };
            const updateddata = await APIService.post('user/delete/webuser', data, true, false);
            setLoader(false);
            getAllWebUser();
            Notify('success', 'User delete  successfully');
        } catch (error) {
            setLoader(false);
            getAllWebUser();
        }
    };

    const clearObjData = () => {
        setUser({ name: null, roleId: null, phone: null, password: null });
    };

    const clearEditObjData = () => {
        setUser({ name: null, roleId: null, phone: null, password: null });
    };

    useEffect(() => {
        getAllWebUser();
        getAllUserRole();
    }, []);

    return (
        <>
            <div className="main_body_cover">
                <div className="container dash-container">
                    <div className="dash_bread_box">
                        <ul>
                            <li>User Management</li>
                        </ul>
                    </div>
                    <div className="content_body_cover">
                        {/* <List
                            headTitles={['Mobile No.', 'Full name', 'Assigned Role']}
                            searchItem={searchItem}
                            list={webUser}
                            updateStatus={updateStatus}
                            getById={handleEdit}
                            getDeleteIds={getDeleteIds}
                            callPagination={getAllWebUser}
                            recordCount={recordCount}
                            addUpdateText="User"
                            addModel="add_model"
                            editModel="add_model"
                            type={'userMangement'}
                            tab={'name...'}
                            handelModel={(e: boolean) => handelModel(e)}
                        /> */}
                        <Lists
                            ref={listRef}
                            headers={columns}
                            data={webUser}
                            searchItem={searchItem}
                            type={'add+delete'}
                            addUpdateText="User"
                            getById={handleEdit}
                            updateStatus={updateStatus}
                            getDeleteIds={getDeleteIds}
                            callPagination={getAllWebUser}
                            recordCount={recordCount}
                            handelModel={(e: boolean) => handelModel(e)}
                        />
                    </div>
                </div>
            </div>
            {showHideModel && (
                <Modal
                    scrollable={true}
                    show={true}
                    onHide={() => handelModel(false)}
                    backdrop="static"
                    keyboard={false}
                    size={'lg'}
                >
                    <Modal.Header closeButton onClick={() => handelModel(false)}>
                        <Modal.Title> {edit ? 'Edit user' : 'Add New user'}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            <div className="material_form_cover">
                                <form
                                    onSubmit={e => {
                                        e.preventDefault();
                                    }}
                                >
                                    <div className="field_box  ">
                                        <div className="row">
                                            <div className="col-sm-6">
                                                <div className="form-floating">
                                                    <TextInput
                                                        data={{
                                                            type: 'text',
                                                            placeholder: 'Full name',
                                                            name: 'name',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="name"
                                                        isSubmit={isSubmit}
                                                        value={edit ? editData?.name : userData?.name}
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.name.message}
                                                        inputProps={errors}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm-6">
                                                <div className="form-floating">
                                                    <TextInput
                                                        data={{
                                                            type: 'number',
                                                            placeholder: 'Mobile Number',
                                                            name: 'phone',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="phone"
                                                        isSubmit={isSubmit}
                                                        value={edit ? editData?.phone : userData?.phone}
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.phone.message}
                                                        inputProps={errors}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-sm-6">
                                                <DropDown
                                                    data={{
                                                        placeholder: 'Select Role',
                                                        name: 'role',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="roleId"
                                                    displayName={'name'}
                                                    optionValue={'id'}
                                                    optionKey={'id'}
                                                    isSubmit={isSubmit}
                                                    value={userData.roleId}
                                                    options={assign}
                                                    setValue={(e: any) => {
                                                        getValue(e);
                                                    }}
                                                    errorMsg={errors?.roleId.message}
                                                    inputProps={errors}
                                                />
                                            </div>
                                            <div className="col-sm-6 ">
                                                <div className="form-floating">
                                                    <TextInput
                                                        data={{
                                                            type: 'password',
                                                            placeholder: 'Password',
                                                            name: 'password',
                                                            id: 'floatingInput',
                                                        }}
                                                        controlName="password"
                                                        isSubmit={isSubmit}
                                                        value={edit ? '' : userData?.password}
                                                        setValue={(e: any) => getValue(e)}
                                                        errorMsg={errors?.password.message}
                                                        inputProps={errors}
                                                    />
                                                    {edit && (
                                                        <p className="smTx">
                                                            <i>Note: Leave it blank if no changes needed</i>
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row last_field_no_margin">
                                            <div className="col-sm-6" style={{ marginTop: '5px' }}>
                                                {/* <DropDown
                                                    data={{
                                                        placeholder: 'Select Demand Type',
                                                        name: 'demand type',
                                                        id: 'floatingInput',
                                                    }}
                                                    controlName="demandType"
                                                    displayName={'name'}
                                                    optionValue={'value'}
                                                    isSubmit={isSubmit}
                                                    value={userData?.demandType}
                                                    options={demandTypeArray}
                                                    setValue={(e: any) => {
                                                        getValue(e);
                                                    }}
                                                    errorMsg={errors?.demandType.message}
                                                    inputProps={errors}
                                                /> */}
                                                <div className="field_box">
                                                    <h3>Demand Type</h3>
                                                    <div className="check_field_box mb-4">
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="flexRadioDefault"
                                                                id="flexRadioDefault1"
                                                                value={'manual'}
                                                                onChange={e => {
                                                                    setUser({
                                                                        ...userData,
                                                                        demandType: e.target.value,
                                                                    });
                                                                }}
                                                                // checked={
                                                                //     userData?.demandType === 'manual' ? true : false
                                                                // }
                                                                checked={
                                                                    userData?.demandType === 'manual' ||
                                                                    !userData?.demandType
                                                                }
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="flexRadioDefault1"
                                                            >
                                                                Manual
                                                            </label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="flexRadioDefault"
                                                                id="flexRadioDefault2"
                                                                value={'auto'}
                                                                onChange={e => {
                                                                    setUser({
                                                                        ...userData,
                                                                        demandType: e.target.value,
                                                                    });
                                                                }}
                                                                checked={userData?.demandType === 'auto' ? true : false}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="flexRadioDefault2"
                                                            >
                                                                Auto
                                                            </label>
                                                        </div>
                                                        <div className="form-check">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="flexRadioDefault"
                                                                id="flexRadioDefault3"
                                                                value={'both'}
                                                                onChange={e => {
                                                                    setUser({
                                                                        ...userData,
                                                                        demandType: e.target.value,
                                                                    });
                                                                }}
                                                                checked={userData?.demandType === 'both' ? true : false}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="flexRadioDefault3"
                                                            >
                                                                Both
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            className="btn dark_btn custom_btn"
                            onClick={edit ? editWebUser : addUser}
                        >
                            {edit ? 'Update' : 'Add'}
                        </Button>
                        <Button
                            variant="default"
                            className="btn custom_btn border_btn with_icon"
                            onClick={() => handelModel(false)}
                        >
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
}

export default UserManagement;
